export enum TableAlign {
  center = 'center',
  right = 'right',
}
